"use client"

import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs"
import { Value } from "@stringtale/react"

const commands = {
  npm: "npx @stringtale/cli init",
  yarn: "yarn install -g @stringtale/cli && @stringtale/cli init",
  yarnberry: "yarn dlx @stringtale/cli init",
  pnpm: "pnpm dlx @stringtale/cli init",
  bun: "bunx @stringtale/cli init",
} as const

export default function InitCommandTabs() {
  return (
    <Tabs defaultValue="npm" className="shadow-[0px_0px_4px_0px_rgba(0,0,0,0.10)]">
      <TabsList className="flex h-[52px] items-center justify-start gap-[18px] rounded-t-[10px] rounded-b-none! border border-b-0 border-black/15 bg-[#fafafa] px-6 py-0 text-[15px] tracking-[0.3px]">
        <TabsTrigger
          value="npm"
          className="h-full rounded-none border-b border-transparent bg-transparent px-1 py-0 text-[15px] font-normal tracking-[0.3px] shadow-none opacity-50 data-[state=active]:border-black data-[state=active]:opacity-100 data-[state=active]:shadow-none"
        >
          <Value name="apps.app.@.components.initcommandtabs.npm">npm</Value>
        </TabsTrigger>
        <TabsTrigger
          value="yarn"
          className="h-full rounded-none border-b border-transparent bg-transparent px-1 py-0 text-[15px] font-normal tracking-[0.3px] shadow-none opacity-50 data-[state=active]:border-black data-[state=active]:opacity-100 data-[state=active]:shadow-none"
        >
          <Value name="apps.app.@.components.initcommandtabs.yarnv1">yarn v1/v2</Value>
        </TabsTrigger>
        <TabsTrigger
          value="yarnberry"
          className="h-full rounded-none border-b border-transparent bg-transparent px-1 py-0 text-[15px] font-normal tracking-[0.3px] shadow-none opacity-50 data-[state=active]:border-black data-[state=active]:opacity-100 data-[state=active]:shadow-none"
        >
          <Value name="apps.app.@.components.initcommandtabs.yarnberry">yarn v3+ (berry)</Value>
        </TabsTrigger>
        <TabsTrigger
          value="pnpm"
          className="h-full rounded-none border-b border-transparent bg-transparent px-1 py-0 text-[15px] font-normal tracking-[0.3px] shadow-none opacity-50 data-[state=active]:border-black data-[state=active]:opacity-100 data-[state=active]:shadow-none"
        >
          <Value name="apps.app.@.components.initcommandtabs.pnpm">pnpm</Value>
        </TabsTrigger>
        <TabsTrigger
          value="bun"
          className="h-full rounded-none border-b border-transparent bg-transparent px-1 py-0 text-[15px] font-normal tracking-[0.3px] shadow-none opacity-50 data-[state=active]:border-black data-[state=active]:opacity-100 data-[state=active]:shadow-none"
        >
          <Value name="apps.app.@.components.initcommandtabs.bun">bun</Value>
        </TabsTrigger>
      </TabsList>
      {Object.entries(commands).map(([key, command]) => (
        <TabsContent
          key={key}
          value={key}
          className="mt-0 flex h-[52px] items-center gap-3 rounded-b-[10px] border border-black/15 bg-white px-6 font-mono text-[16px] tracking-[0.32px]"
        >
          <span className="opacity-50">1</span>
          <code>{command}</code>
        </TabsContent>
      ))}
    </Tabs>
  )
}
